import { render, staticRenderFns } from "./AdminSystemSettingsView.vue?vue&type=template&id=9c341548&scoped=true&"
import script from "./AdminSystemSettingsView.vue?vue&type=script&lang=js&"
export * from "./AdminSystemSettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c341548",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCombobox,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c341548')) {
      api.createRecord('9c341548', component.options)
    } else {
      api.reload('9c341548', component.options)
    }
    module.hot.accept("./AdminSystemSettingsView.vue?vue&type=template&id=9c341548&scoped=true&", function () {
      api.rerender('9c341548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminSystemSettingsView.vue"
export default component.exports